<!-- Header (minimal) -->
<div class="multifirm_header width-full" [style.background-image]="'url('+ firm?.logo_fullsize +')'"></div>

<div class="pagecontent" style="margin: 50px O 350px 0">
    <div class="view-seoindex">
        <div class="centered width-40">

          <form #formPassword="ngForm">
            <p class="password-title align-center weight-300 font-20">{{ 'ENTER_DEMO_PASSWORD' | translate }}</p>
            <div class="input">
              <div class="inputfield">
                  <input required="required" name="password" type="password" value="" id="password" [(ngModel)]="password" placeholder="{{ 'PASSWORD' | translate }}" #passwordRef="ngModel" required>
              </div>
            </div>
            <div class="buttons">
              <button class="btn-fill buttons password-btn width-full" (click)="enterDemoPassword()" [disabled]="formPassword.invalid">{{ 'LOGIN' | translate }}<span class="arrow"></span></button>
            </div>
          </form>

          <p *ngIf="password_error == true" class="password-error color-red align-center" text-center>{{ 'PASSWORD_INCORRECT' | translate }}</p>

          <div text-center class="font-14 align-center">
            <p class="weight-300">{{ 'ORDER_WITH_PASSWORD' | translate }}</p>
          </div>

          <div text-center class="font-14 align-center">
            <p class="weight-300">{{ 'FIND_DEMO_PASSWORD' | translate }}</p>
          </div>

        </div>
    </div>
</div>

<!-- Footer -->
<app-footer *ngIf="!firmService.checkEmbed()"></app-footer>